import Vue from 'vue';
import toast from './toast.vue';

const NotificationConstructor = Vue.extend(toast);

let instance;
let seed = 1;
const instances = [];

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
}
const $toast = (options) => {
  if (Vue.prototype.$isServer) return;
  options = options || {};
  const userOnClose = options.onClose;
  const id = `message_${seed += 1}`;
  options.onClose = () => {
    $toast.close(id, userOnClose);
  };
  instance = new NotificationConstructor({
    data: options,
  });
  instance.id = id;
  if (isVNode(options.message)) {
    instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }
  instance.dataObj = options;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.$el);
  instance.vm.isShowToast = true;
  instances.push(instance);
  instance.close();
  return instance.vm;
};
$toast.close = (id, userOnClose) => {
  for (let i = 0, len = instances.length; i < len; i += 1) {
    if (id === instances[i].id) {
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
};
export default $toast;
